export const ACTIVE_PROJECT_KEY = 'asystowo.activeProjectId';

export function activeProjectId() {
  return window.localStorage.getItem(ACTIVE_PROJECT_KEY);
}

export function selectProject(id: string | null) {
  if (id) window.localStorage.setItem(ACTIVE_PROJECT_KEY, id);
  else window.localStorage.removeItem(ACTIVE_PROJECT_KEY);
  window.dispatchEvent(new CustomEvent('asystowo:project-change', { detail: id }));
}

export async function api<T>(url: string, options?: RequestInit): Promise<T> {
  const headers = new Headers(options?.headers);
  const projectId = activeProjectId();
  if (projectId) headers.set('x-project-id', projectId);
  const response = await fetch(url, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || `Błąd ${response.status}`);
  return data as T;
}

export const currency = (value?: number | string | null) => value == null ? '—' : `${new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 }).format(Number(value))} zł`;
export const number = (value?: number | string | null) => value == null ? '—' : new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 1 }).format(Number(value));
export const shortDate = (value?: string | null) => value ? new Intl.DateTimeFormat('pl-PL', { day: '2-digit', month: 'short' }).format(new Date(value)).toUpperCase().replace('.', '') : 'Bez terminu';

export function googleMapsDirectionsUrl(location: { latitude?: number | null; longitude?: number | null; address?: string | null; city?: string | null }) {
  const destination = location.latitude != null && location.longitude != null
    ? `${location.latitude},${location.longitude}`
    : location.address || location.city;
  if (!destination) return null;
  const parameters = new URLSearchParams({ api: '1', destination, travelmode: 'driving', dir_action: 'navigate' });
  return `https://www.google.com/maps/dir/?${parameters.toString()}`;
}
